import { CapacityEntity } from '../../types';

export const filterPastEntries = (entries: CapacityEntity[]) => {
  const index = entries.filter(
    (entry: CapacityEntity) => new Date(entry.startDate.split('T')[0]).getTime() < new Date().getTime(),
  ).length;
  return entries.slice(index - 1);
};

export const getAdjustedWeeksForTemplate = (
  validityPeriod: string,
  entriesSOC: CapacityEntity[],
  entriesYard: CapacityEntity[],
) => {
  const weeks: string[] = [];
  const startDate = new Date(validityPeriod.substring(0, 10).replaceAll('/', '-'));
  const endDate = new Date(validityPeriod.substring(13, 23).replaceAll('/', '-'));
  entriesSOC.forEach((entry: CapacityEntity) => {
    const date = new Date(entry.timestamp);
    if (entry.entries[0].overwrite && startDate <= date && endDate > date) {
      weeks.push(`${entry.date} SOC`);
    }
  });
  entriesYard.forEach((entry: CapacityEntity) => {
    const date = new Date(entry.timestamp);
    if (entry.entries[0].overwrite && startDate <= date && endDate > date) {
      weeks.push(`${entry.date} Yard`);
    }
  });
  return weeks;
};
